module.exports = __webpack_public_path__ + "static/media/profile_photo_2.2aacf892.jpeg";